/*=========================================================================================
  File Name: module-usertax.js
  Description: UserTax Module
  ----------------------------------------------------------------------------------------
  Project: MISA InvoiceBots
  Author: MISA JSC
  Author URL: http://www.misa.com.vn
==========================================================================================*/

import state from './module-comfirm-vat-rate-state';
import mutations from './module-comfirm-vat-rate-mutations';
import actions from './module-comfirm-vat-rate-actions';
import getters from './module-comfirm-vat-rate-getters';

export default {
	debug: process.env.NODE_ENV !== 'production',
	namespaced: true,
	state,
	mutations,
	actions,
	getters
};
